"use strict";

exports.__esModule = true;
exports["default"] = ReactLoadableComponent;

var _baseLazyComponent = _interopRequireDefault(require("./base-lazy-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ReactLoadableComponent(name, resolve, files) {
  if (files === void 0) {
    files = [];
  }

  return /*#__PURE__*/function (_BaseLazyComponent) {
    _inheritsLoose(LoadableComponent, _BaseLazyComponent);

    function LoadableComponent(props) {
      var _this;

      _this = _BaseLazyComponent.call(this, props, {
        component: name,
        files: files,
        resolve: resolve
      }) || this;
      _this.state = {
        component: null
      };
      return _this;
    }

    var _proto = LoadableComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.resourceLoader.then(function () {
        if (_this2.resolvedData) {
          var component = _this2.resolvedData["default"] || _this2.resolvedData;

          if (component) {
            _this2.setState({
              component: component
            });
          }
        }
      });
    };

    _proto.render = function render() {
      if (this.state.error) {
        throw this.state.error;
      }

      return this.renderComponent();
    };

    return LoadableComponent;
  }(_baseLazyComponent["default"]);
}